import { Modal as SimpleModal } from '@/components/custom/modal/modal';
import React from 'react';
import styles from './DetailModal.module.scss';
import SkillTree from './SkillTree';
import PositionsCompatibility from './PositionsCompatibility';
import { ProfileBanner, ProfileBannerInner, ProfileBannerHeader, ProfileBannerData, ProfileBannerTitle, ProfileBannerInfoWrapper, ProfileBannerInfo } from '@/components/custom/profile/profile-banner';
import { AvatarWrapper } from '@/components/ui/avatar';
import AnswerKey from './AnswerKey';

export default function DetailModal(props) {
  const { show, onClose } = props;

  return (
    <SimpleModal
      show={show}
      onClose={onClose}
      contentClassName="simple-modal__content--full simple-modal__content--br-md"
      hideCloseButton
    >
      <div className={styles.wrapper}>
        <ProfileBanner>
          <ProfileBannerInner>
            <AvatarWrapper
              name="Felipe Brandão de Oliveira"
              size="lg"
            />
            <ProfileBannerHeader>
              <ProfileBannerData>
                <ProfileBannerTitle>Felipe Brandão de Oliveira</ProfileBannerTitle>
                <ProfileBannerInfoWrapper>
                  <ProfileBannerInfo>Área: Produto</ProfileBannerInfo>
                  <ProfileBannerInfo>Cargo: Vendedor</ProfileBannerInfo>
                </ProfileBannerInfoWrapper>
              </ProfileBannerData>
            </ProfileBannerHeader>
          </ProfileBannerInner>
        </ProfileBanner>
        <PositionsCompatibility />
        <SkillTree />
        <AnswerKey />
      </div>
    </SimpleModal>
  );
}
